/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */

Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.TimeField = (function() {
  function TimeField() {
    Monet.UI.Fields.TextField.apply(this, arguments);
    this.onChange = () => undefined;
    this.createElement = function() {
      this.input = document.createElement("input");
      
      this.input.type = "text";
      this.input.className = "timeField";
      
      if (this.maxSize) {
        this.input.maxLength = this.maxSize;
      }
      
      this.rootEl.appendChild(this.input);
    };

    this.getValue = function() {
      if (Monet.I18n.locale.timeFormat !== "HH:mm" && this.input.value) {
        return moment(this.input.value, Monet.I18n.locale.timeFormat).format(
          "HH:mm"
        );
      }
      return this.input.value;
    };

    this.setValue = function(value) {
      if (value || value === "" || value === 0) {
        this.value = value;
      }

      this.setInputValue();
      this.onChange();
    };

    this.setInputValue = function() {
      if (this.input && this.value) {
        let format;
        format = Monet.I18n.locale.timeFormat;
        this.input.value = moment(
          this.value,
          Monet.I18n.locale.timeFormat
        ).format(format);
      }
    };

    this.initializeSpecialBehavior = function() {
      new Monet.Date.GeneralFunctions().setTimePicker(this.input);
    };

    this.setOnBlur = (onBlur) => {
      if (onBlur) {
          this.onBlur = onBlur;
      }
    };

    this.setOnFocus = (onFocus) => {
        if (onFocus) {
            this.onFocus = onFocus;
        }
    };
    
    this.setOnChange = (onChange) => {
      if (onChange) {
          this.onChange = onChange;
      }
    };
  

    this.render = function() {
      this.createElement();
      this.setInputValue();
      this.initializeSpecialBehavior();
      return this.rootEl;
    };
  }

  return TimeField;
})();
